import React from "react";
import { Link } from "react-router-dom";

export const ProductCard = ({ product }) => {
  const isComingSoon = product.comingSoon;
  const hasImage = product.images && product.images.length > 0;

  const content = (
    <>
      <div className="relative overflow-hidden aspect-[3/4] bg-[color:var(--ssm-surface)]">
        {hasImage ? (
          <>
            <img
              src={product.images[0]}
              alt={product.name}
              className="w-full h-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-105"
              loading="lazy"
            />
            {product.images[1] && (
              <img
                src={product.images[1]}
                alt={`${product.name} alternate`}
                className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                loading="lazy"
              />
            )}
          </>
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="font-display text-3xl text-neutral-300 italic">
              {product.name}
            </span>
          </div>
        )}
        {isComingSoon && (
          <div className="absolute top-3 left-3 bg-black text-white text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
            Coming soon
          </div>
        )}
      </div>
      <div className="flex flex-col gap-1">
        <h3 className="text-sm md:text-base font-medium">{product.name}</h3>
        {isComingSoon ? (
          <span className="text-sm text-neutral-500 italic">Coming soon</span>
        ) : (
          <span className="text-sm text-neutral-500">${product.price.toFixed(2)}</span>
        )}
      </div>
    </>
  );

  if (isComingSoon) {
    return (
      <div
        data-testid={`product-card-${product.slug}`}
        className="group flex flex-col gap-4 cursor-default"
      >
        {content}
      </div>
    );
  }

  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group flex flex-col gap-4"
    >
      {content}
    </Link>
  );
};
